"use client";

import { WEB_COLORS } from "./constants/Colors";

const { createTheme } = require("@mui/material");
export const THEME = createTheme({
  palette: {
    primary: {
      main: WEB_COLORS.primary,
    },
    secondary: {
      main: WEB_COLORS.secondary,
    },
    pale: {
      main: WEB_COLORS.pale,
    },
    orange: {
      main: WEB_COLORS.orange,
    },
  },
  typography: {
    fontFamily: "inherit",
  },
});
